import React, { Component, Fragment } from 'react';
import sensors from 'sa-sdk-javascript';

import { setSensors } from '../utils/sensors';
import bog from '../utils/moreBog';
import { handleGwData } from '../actions/actionsFactory';
import { fetchUrlAndProject } from '../actions/actionsSet/common';

export default class Sensorsdata extends Component {
  async componentDidMount() {
    try {
      const result = handleGwData(await fetchUrlAndProject());

      sensors.init({
        // capture spa webview, like lending page and margin order page
        is_track_single_page: true,
        server_url: result.server || '',
        heatmap: {
          collect_elements: 'all',
        },
        name: 'SensorsSdk',
        show_log: false,
      });
      sensors.quick('autoTrackSinglePage');
      setSensors(sensors);
    } catch (error) {
      bog.error(error);
    }
  }

  render() {
    return <Fragment>{null}</Fragment>;
  }
}
